import { createTheme, alpha } from '@mui/material/styles';
import { colors, radii, shadows, typography, tokens } from '../styles/tokens';

const displayHeading = {
  fontFamily: typography.fontFamilyDisplay,
  fontWeight: 600,
  color: colors.textPrimary,
  letterSpacing: '-0.01em',
};

export const getLightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: colors.primary,
      light: alpha(colors.primary, 0.85),
      dark: colors.primaryDark,
      contrastText: '#FDF3EC',
    },
    secondary: {
      main: colors.accent,
      light: '#2E8A74',
      dark: '#14544A',
      contrastText: '#FFFFFF',
    },
    background: {
      default: colors.background,
      paper: colors.paper,
    },
    text: {
      primary: colors.textPrimary,
      secondary: colors.textSecondary,
      disabled: colors.textMuted,
    },
    divider: colors.border,
    success: { main: colors.success, contrastText: '#FFFFFF' },
    warning: { main: colors.warning, contrastText: '#FFFFFF' },
    error: { main: colors.error, contrastText: '#FFFFFF' },
    info: { main: colors.info, contrastText: '#FFFFFF' },
    action: {
      hover: alpha(colors.primary, 0.06),
      selected: alpha(colors.primary, 0.1),
    },
  },
  typography: {
    fontFamily: typography.fontFamily,
    h1: displayHeading,
    h2: displayHeading,
    h3: displayHeading,
    h4: displayHeading,
    h5: displayHeading,
    h6: displayHeading,
    body1: { fontWeight: typography.weights.regular, color: colors.textPrimary },
    body2: { fontWeight: typography.weights.regular, color: colors.textSecondary },
    subtitle1: { fontWeight: typography.weights.medium, color: colors.textSecondary },
    subtitle2: { fontWeight: typography.weights.medium, color: colors.textSecondary },
  },
  shape: {
    borderRadius: radii.button,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: colors.background,
          color: colors.textPrimary,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: typography.weights.medium,
          borderRadius: radii.badge,
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: shadows.hover,
          },
        },
        outlined: {
          borderColor: colors.border,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: colors.paper,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: colors.paper,
          border: `1px solid ${colors.border}`,
          borderRadius: radii.card,
          boxShadow: shadows.resting,
          transition: 'box-shadow 150ms ease',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: radii.input,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: radii.badge,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: colors.background,
          color: colors.textPrimary,
          boxShadow: 'none',
          borderBottom: `1px solid ${colors.border}`,
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: radii.button,
        },
      },
    },
  },
});

export { tokens as getThemeTokens };
